export const loginScreen = {
  background: {
    width: "100%",
    height: "100vh",
    minHeight: "100%",
    display: "flex",
    justifyContent: "center",
  } as React.CSSProperties,
  loginInput: {
    zIndex: 1,
    display: "flex",
  } as React.CSSProperties,
  rightsText: {
    color: "white",
  },
  innerAppView: {
    marginLeft: "calc(50% - 40vw)",
    marginRight: "calc(50% - 40vw)",
  },
};
